import API from "../Utils/API";

export const sendOtp =
  (phone, successCallBack, failureCallBack) => (dispatch) => {
    dispatch({ type: "SEND_OTP_REQUEST" });

    API.post("/otps/send_otp", { phone })
      .then((response) => {
        dispatch({ type: "SEND_OTP_SUCCESS", payload: response.data });
        successCallBack && successCallBack(response.data);
      })
      .catch((error) => {
        dispatch({
          type: "SEND_OTP_FAILURE",
          payload: error.response?.data,
        });
        failureCallBack && failureCallBack(error.response?.data);
      });
  };

  export const verifyOtp =
  (phone, otp, successCallBack, failureCallBack) => (dispatch) => {
    dispatch({ type: "VERIFY_OTP_REQUEST" });

    API.post("/otps/verify_otp", { phone, otp })
      .then((response) => {
        dispatch({ type: "VERIFY_OTP_SUCCESS", payload: response.data });
        successCallBack && successCallBack(response.data);
      })
      .catch((error) => {
        dispatch({
          type: "VERIFY_OTP_FAILURE",
          payload: error.response?.data,
        });
        failureCallBack && failureCallBack(error.response?.data);
      });
  };  